module.exports = __webpack_public_path__ + "static/img/24.e244728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24.png
// module id = JXny
// module chunks = 0